<template>
  <div>
    <div class="btn-large wide-btn rounded-btn mt-25" @click="pay" v-if="showBtn">
      {{ $t("sendBill.payByBankApp") }}
    </div>
    <section v-else>
      <div class="center mt-25 mb-25">
        <div class="bold-font grey-text text-darken-3">
          <div style="font-size: 14px !important;">
            {{ $t("sendBill.withBankAppTo") }}
          </div>
        </div>
      </div>

      <div class="center mt-25">
        <div class="bold-font emerald" style="font-size: clamp(24px, 8vw, 40px);">
          {{ merchantName }}
        </div>
      </div>

      <div class="instructions-container center mt-35 mb-25">
        <div class="emerald mb-15">
          <i class="fas fa-exclamation-triangle" style="font-size: 40px;"></i>
        </div>
        
        <div class="instruction-text-wrapper">
          <p class="grey-text text-darken-3 instruction-text">
            {{ $t("sendBill.instructionStep1") }}<br>
            {{ $t("sendBill.instructionStepDisplayName") }}<br>
            {{ $t("sendBill.instructionStep2") }}<br>
            <span v-if="invoice">{{ $t("sendBill.instructionStep3WithInvoice") }}</span>
          </p>
        </div>
      </div>

      <!-- 1st block - Zelle ID -->
      <div class="copy-block-container" @click="copyZelleId(zelleId)">
        <div class="number-circle">
          <div class="number-circle-white">
            <div class="number-circle-emerald">
              <span>1</span>
            </div>
          </div>
        </div>
        <div class="copy-block">
          <div class="copy-text">{{ $t("sendBill.at") }} {{ zelleId }}</div>
          <a class="copy-icon">
            <i class="fas fa-clipboard emerald"></i>
          </a>
        </div>
      </div>

      <!-- 2nd block - Zelle Display Name -->
      <div class="copy-block-container" @click="copyDisplayName(zelleDisplayName)">
        <div class="number-circle">
          <div class="number-circle-white">
            <div class="number-circle-emerald">
              <span>2</span>
            </div>
          </div>
        </div>
        <div class="copy-block">
          <div class="copy-text">{{ zelleDisplayName }}</div>
          <a class="copy-icon">
            <i class="fas fa-clipboard emerald"></i>
          </a>
        </div>
      </div>
      
      <!-- 3d block - Amount -->
      <div class="copy-block-container" @click="copyAmount(amountNumberParam)">
        <div class="number-circle">
          <div class="number-circle-white">
            <div class="number-circle-emerald">
              <span>3</span>
            </div>
          </div>
        </div>
        <div class="copy-block">
          <div class="copy-text">{{ $t("sendBill.amount") }} {{ amountNumberParam | currency }}</div>
          <a class="copy-icon">
            <i class="fas fa-clipboard emerald"></i>
          </a>
        </div>
      </div>
      
      <!-- 4th block - Invoice -->
      <div v-if="invoice" class="copy-block-container" @click="copyInvoice(invoice)">
        <div class="number-circle">
          <div class="number-circle-white">
            <div class="number-circle-emerald">
              <span>4</span>
            </div>
          </div>
        </div>
        <div class="copy-block">
          <div class="copy-text">{{ $t("sendBill.invoice") }} {{ invoice }}</div>
          <a class="copy-icon">
            <i class="fas fa-clipboard emerald"></i>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { toRefs } from '@vue/composition-api'
  import { useBaseStore } from "./base_store"

  export default {
    setup() {
      const baseStore = useBaseStore();

      return { ...toRefs(baseStore) }
    },
    props: ['linkOrderId', 'zelleId', 'zelleDisplayName', 'merchantName', 'showOnePaymentOptionForm', 'invoice', 'amountNumberParam'],
    data() {
      return {
        showBtn: true,
        clientSecret: null,
        paymentIntentId: null,
        redirectUrl: null,
        loading: false,
        pending: false
      }
    },
    methods: {
      pay() {
        this.showBtn = false
        this.selectedFlow = ['zelle']
        this.$ahoy.track("opened_zelle_link", { link_order_id: this.linkOrderId, amount: this.amountNumberParam, zelle_id: this.zelleId })
      },
      copyZelleId(text) {
        this.$copyText(text).then( result => {
          this.notifySuccess(this.$t("sendBill.idCopied"))
          this.$ahoy.track("zelle_id_copy", { link_order_id: this.linkOrderId, zelle_id: this.zelleId })
        })
      },
      copyDisplayName(text) {
        this.$copyText(text).then( result => {
          this.notifySuccess(this.$t("sendBill.displayNameCopied"))
          this.$ahoy.track("zelle_display_name_copy", { link_order_id: this.linkOrderId, display_name: text })
        })
      },
      copyAmount(amount) {
        this.$copyText(amount).then( result => {
          this.notifySuccess(this.$t("sendBill.amountCopied"))
          this.$ahoy.track("zelle_amount_copy", { link_order_id: this.linkOrderId, amount: amount })
        })
      },
      copyInvoice(text) {
        this.$copyText(text).then( result => {
          this.notifySuccess(this.$t("sendBill.invoiceCopied"))
          this.$ahoy.track("zelle_invoice_copy", { link_order_id: this.linkOrderId, invoice: this.invoice })
        })
      },
      cancelPayment() {
        this.showBtn = true
        this.selectedFlow = []
      }
    }
  }
</script>

<style scoped>
.copy-block-container {
  position: relative;
  margin: 30px auto 20px 40px; /* Add left margin to make space for circle */
  width: 356px; /* Base width from Figma */
  max-width: 80%; /* Ensure it doesn't overflow on mobile */
  height: 80px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.instruction-text-wrapper {
  width: 95%;
  max-width: 500px;
  margin: 0 20px 0 20px; /* Match the left margin of the copy blocks */
  text-align: left;
}

.instruction-text {
  line-height: 1.6;
  font-size: 16px;
}

@media (min-width: 768px) {
  .instruction-text-wrapper {
    margin-left: 70px; /* Match the responsive margins */
  }
}

@media (min-width: 1200px) {
  .instruction-text-wrapper {
    margin-left: 80px;
  }
}

/* Media queries for responsive design */
@media (min-width: 768px) {
  .copy-block-container {
    width: 400px;
    margin-left: 70px; /* Adjust left margin for larger screens */
  }
}

@media (min-width: 1200px) {
  .copy-block-container {
    width: 450px;
    margin-left: 80px; /* Further adjust for very large screens */
  }
}

.number-circle {
  position: absolute;
  width: 58px;
  height: 58px;
  left: -30px; /* More to the left to be outside the rectangle */
  top:-15px;
  background: #FFFFFF;
  border-radius: 50%;
  z-index: 2;
}

.number-circle-white {
  position: absolute;
  width: 58px;
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number-circle-emerald {
  position: relative;
  width: 50px;
  height: 50px;
  background: #00AB8E;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number-circle-emerald span {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
}

.copy-block {
  position: relative;
  width: 100%;
  height: 80px;
  background: #F5F5F5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 50px;
  padding-right: 40px;
  z-index: 1;
}

.copy-text {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #696969;
  word-break: break-all;
}

.copy-icon {
  position: absolute;
  right: 20px;
  cursor: pointer;
}

.copy-icon i {
  font-size: 20px;
}
</style>

